// extracted by mini-css-extract-plugin
var _1 = "Checkbox_chooseManyCheckbox__JZ5Lh";
var _2 = "Checkbox_chooseManyCheckmark__SNVk8";
var _3 = "768px";
var _4 = "\"../../../shared.module.css\"";
export { _1 as "chooseManyCheckbox", _2 as "chooseManyCheckmark", _3 as "md", _4 as "shared" }
